import { useMessage } from 'naive-ui'
import { useI18n } from 'vue-i18n'

export function useComingSoonMessage() {
  const message = useMessage()
  const { t } = useI18n()

  return (messageType) => {
    message.info(messageType === 'social' ? t('此社区正在筹备中，敬请期待！') : t('此功能正在搭乘研发火箭，发射筹备中，敬请期待！'), {
      showIcon: false,
      duration: 3000,
      closable: false,
    })
  }
}
